module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kalinga Restoration Project","short_name":"Kalinga","start_url":"/","background_color":"#FFFEFA","theme_color":"#262827","display":"minimal-ui","icon":"src/images/kalinga/lsc-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"360c9309e7701450676f5bdd4a7c86bc"},
    }]
